export enum DefaultTheme {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum CustomTheme {
  dharmann = 'dhar-mann',
  khruanguin = 'khruangbin',
  grandaddy = 'grandaddy',
  drjenniferashuy = 'dr-jennifer-ashby',
  ARGO = 'argo',
  MyJokes = 'my-jokes',
  Abraham = 'abraham',
  StreetFair = 'street-fair',
}

export type Theme = DefaultTheme | CustomTheme;
